/**
 * A soft two-tone confirmation chime, synthesised with the Web Audio API so
 * there's no audio asset to bundle or load. Used the instant an Anna accepts a
 * ride — reassurance even if the passenger isn't looking at the screen. The
 * haptic + toast are the primary cues; if audio is blocked or unavailable this
 * fails silently and nothing else is affected.
 */
let ctx = null;

const getCtx = () => {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    if (!ctx) ctx = new AC();
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});
    return ctx;
  } catch {
    return null;
  }
};

/** Call from a user gesture (e.g. the booking tap) so the context is unlocked
 *  by the time the "Anna assigned" event fires seconds later. */
export const warmChime = () => { getCtx(); };

export const playAssignedChime = () => {
  try {
    const ac = getCtx();
    if (!ac || ac.state !== 'running') return;

    const now = ac.currentTime;
    const master = ac.createGain();
    master.gain.value = 0.0001;
    master.connect(ac.destination);

    // gentle swell in, hold, fade out — never a harsh click
    master.gain.setValueAtTime(0.0001, now);
    master.gain.exponentialRampToValueAtTime(0.18, now + 0.04);
    master.gain.exponentialRampToValueAtTime(0.0001, now + 0.9);

    // two soft sine tones, a rising major third (E5 → G#5)
    [[659.25, 0], [830.61, 0.14]].forEach(([freq, offset]) => {
      const osc = ac.createOscillator();
      const g = ac.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, now + offset);
      g.gain.exponentialRampToValueAtTime(1, now + offset + 0.03);
      g.gain.exponentialRampToValueAtTime(0.0001, now + offset + 0.55);
      osc.connect(g);
      g.connect(master);
      osc.start(now + offset);
      osc.stop(now + offset + 0.6);
    });
  } catch {
    /* audio unavailable — the haptic + toast still fire */
  }
};
